import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { OperationExpense } from '../types'
import CellPrice from '@/components/GokuDataGrid/CellPrice'

// Category color mapping
const getCategoryColor = (category: string) => {
    const colorMap: Record<string, string> = {
        general_operations: 'bg-gray-100 text-gray-700',
        office: 'bg-blue-100 text-blue-700',
        salaries: 'bg-purple-100 text-purple-700',
        marketing: 'bg-pink-100 text-pink-700',
        sales: 'bg-green-100 text-green-700',
        technology: 'bg-indigo-100 text-indigo-700',
        training: 'bg-yellow-100 text-yellow-700',
        travel: 'bg-orange-100 text-orange-700',
        utilities: 'bg-teal-100 text-teal-700',
        insurance: 'bg-cyan-100 text-cyan-700',
        legal: 'bg-red-100 text-red-700',
        maintenance: 'bg-lime-100 text-lime-700',
        supplies: 'bg-amber-100 text-amber-700',
        other: 'bg-slate-100 text-slate-700',
    }
    return colorMap[category] || 'bg-gray-100 text-gray-700'
}

export const columns: (t: Function) => GridColDefVNW<OperationExpense>[] = (
    t
) => [
    {
        field: 'report_month',
        headerName: 'report_month',
        width: 150,
    },
    {
        field: 'category',
        headerName: 'category',
        width: 150,
        renderCell: ({ value }) => (
            <span
                className={`inline-flex items-center px-2 py-1 rounded text-xs ${getCategoryColor(
                    value
                )}`}
            >
                {t(`expense_category_${value}`)}
            </span>
        ),
    },
    {
        field: 'expense_name',
        headerName: 'expense_name',
        width: 250,
        flex: 1,
    },
    {
        field: 'amount',
        headerName: 'amount',
        width: 180,
        align: 'right',
        renderCell: ({ value }) => (
            <CellPrice price={value} className="text-red-700" />
        ),
    },
    {
        field: 'notes',
        headerName: 'notes',
        width: 300,
        renderCell: ({ value }) => (
            <div className="text-sm text-gray-600 truncate">{value || '-'}</div>
        ),
    },
]
